import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material';
import produce from 'immer';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutateUserRolePreferences } from '../../../../api/userrolepreferences/hooks';
import { UserRolePreferencesSettings } from '../../../../api/userrolepreferences/types';
import { Filter, FilterTypes } from '../filterbar/types';
import { DialogHandle, MyFiltersGroup } from './types';

interface DeleteDialogProps<T extends FilterTypes> {
  group: MyFiltersGroup<T>;
  currentRolePreferences: UserRolePreferencesSettings<Filter> | null;
  dialogHandle: DialogHandle;
}

export const DeleteDialog = <T extends FilterTypes>(
  props: DeleteDialogProps<T>
) => {
  const { t } = useTranslation();
  const { group, currentRolePreferences, dialogHandle } = props;
  const [open, setOpen] = dialogHandle;
  const [saveError, setSaveError] = useState('');
  const userRolePreferencesService = useMutateUserRolePreferences<Filter>();
  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setSaveError('');
          const newSettings = produce(
            currentRolePreferences?.settings ?? {
              myFilterGroups: [] as MyFiltersGroup<Filter>[],
              profile: {},
            },
            (draft) => {
              draft.myFilterGroups = draft.myFilterGroups?.filter(
                (g) => g.id !== group.id
              );
            }
          );
          userRolePreferencesService.mutate(newSettings, {
            onSuccess: () => setOpen(false),
            onError: () =>
              setSaveError(
                t('common:filterTray.saveError', {
                  name: group.name ?? 'unknown',
                })
              ),
          });
        }}
      >
        <DialogTitle>
          {t('common:filterTray.delete')} {group.name}
        </DialogTitle>
        {saveError && <p>{saveError}</p>}
        <DialogActions sx={{ paddingBottom: '1em' }}>
          <Button type="submit" variant="contained">
            {t('common:filterTray.delete')}
          </Button>
          <Button onClick={() => setOpen(false)} variant="outlined">
            {t('common:filterTray.cancel')}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
